import { lib } from '@gocanvas/client'
const {
  LABELS_LEFT_SHEET_TYPE_ID,
  LABELS_LEFT_ENTRY_LABEL_LENGTH,
  SINGLE_PHOTO_ORIGINAL_TYPE_ID,
  TILE_PHOTO_ENTRY_LABEL_LENGTH,
} = lib 

export const getEntryLabelLimit = (sheet = {}, entry = {}) => {
  const { sheet_type_id } = sheet
  const { original_type_id, uses_caption_format } = entry

  if (sheet_type_id == LABELS_LEFT_SHEET_TYPE_ID) {
    // Screens with the label left style are limited to 30 characters for entry labels
    return LABELS_LEFT_ENTRY_LABEL_LENGTH
  } else if (original_type_id == SINGLE_PHOTO_ORIGINAL_TYPE_ID && uses_caption_format) {
    // Single photo entries with the Tile Photo option enabled are limited to 30 characters for entry labels
    return TILE_PHOTO_ENTRY_LABEL_LENGTH
  }
  return null
}
